export const priceListCollectionGuard = 'GET /price-lists';
export const priceListResourceGuard = 'GET /price-lists/d+';
export const priceListParentsCollectionGuard = 'GET /price-lists/parents';
export const priceListReferenceCollectionGuard = 'GET /price-lists/d+';
export const createPriceResourceListGuard = 'POST /price-lists';
export const editPriceResourceListGuard = 'PUT /price-lists/d+';
export const deletePriceResourceListGuard = 'DELETE /price-lists/d+';
